import { cloneDeep } from "lodash";
const replaceColumnField = (providedColumn, newColumn, selectedDropDownProps) => {
    if (providedColumn.field?.startsWith("$")) {
        const [, index] = providedColumn.field;
        newColumn.field = providedColumn.field?.replace(`$${index}`, selectedDropDownProps[index]?.field);
    }
};
const replaceColumnHeader = (providedColumn, newColumn, selectedDropDownProps) => {
    if (providedColumn.headerName?.startsWith("$")) {
        const [, index] = providedColumn.headerName;
        newColumn.headerName = selectedDropDownProps[index]?.displayName;
    }
};
const replaceColumnType = (providedColumn, newColumn, selectedDropDownProps) => {
    if (!Array.isArray(providedColumn.type) && providedColumn?.type?.startsWith("$")) {
        const [, index] = providedColumn.type;
        newColumn.type = selectedDropDownProps[index]?.valueFormat?.toString();
    }
    else if (Array.isArray(providedColumn.type) && providedColumn?.type?.some((s) => s?.startsWith("$"))) {
        const elementToReplaceIndex = providedColumn.type.findIndex((s) => s?.startsWith("$"));
        if (elementToReplaceIndex !== -1 && Array.isArray(newColumn.type)) {
            const [, index] = providedColumn.type[elementToReplaceIndex];
            newColumn.type[elementToReplaceIndex] = selectedDropDownProps[index]?.valueFormat?.toString();
        }
    }
};
const replaceValuesFromDataSelectPropsOnColDef = (column, columns, selectedDropDownProps) => {
    if (!column) {
        return column;
    }
    const newColumn = { ...column };
    replaceColumnField(column, newColumn, selectedDropDownProps);
    replaceColumnHeader(column, newColumn, selectedDropDownProps);
    replaceColumnType(column, newColumn, selectedDropDownProps);
    if (newColumn.children) {
        newColumn.children = column?.children?.map((c) => replaceValuesFromDataSelectPropsOnColDef(c, columns, selectedDropDownProps));
    }
    return newColumn;
};
const fillColumnsItemsFromSelectProps = (columns, dataSelectProps, selectedValues) => {
    let finalColumns = columns;
    if (!finalColumns || !dataSelectProps || !selectedValues) {
        return columns;
    }
    let selectedDropDownProps = [];
    if (Object.keys(selectedValues).length !== 0) {
        selectedDropDownProps = Object.entries(selectedValues)
            .map(([key, value]) => dataSelectProps[parseInt(key, 10)]?.selectValues[value] ?? {});
    }
    if (!selectedDropDownProps) {
        return columns;
    }
    finalColumns = finalColumns.map((newCol) => {
        const newColumn = replaceValuesFromDataSelectPropsOnColDef(newCol, columns, selectedDropDownProps);
        if (newCol.children) {
            newColumn.children = newCol.children.map((columnChild) => replaceValuesFromDataSelectPropsOnColDef(columnChild, finalColumns, selectedDropDownProps));
        }
        return newColumn;
    });
    return finalColumns;
};
const transformColumn = (column, filledActionsOnColumns) => {
    let transformedColumn = cloneDeep(column);
    if (column.children) {
        transformedColumn.children = transformedColumn.children.map((col) => transformColumn(col, filledActionsOnColumns));
    }
    else {
        filledActionsOnColumns.forEach((action) => {
            if (action.id === column.id) {
                transformedColumn = { ...action, ...column };
            }
        });
    }
    return transformedColumn;
};
export const generateColumnsFromActions = (columns, actionsOnColumns, dataSelectProps, selectedValues) => {
    const filledActionsOnColumns = fillColumnsItemsFromSelectProps(cloneDeep(actionsOnColumns), dataSelectProps, selectedValues);
    return columns.map((col) => transformColumn(col, filledActionsOnColumns));
};
